export enum FormStatus {
    Close = -1,
    Add = 1,
    Edit = 2
}